export default __webpack_public_path__ + "static/media/white-thumb-up.d8d6cdc6.svg";